module.exports = __webpack_public_path__ + "img/img13.9ed7b455.svg";